import {
  DsoCartErrorCode,
  DsoCartValidationError,
} from 'types/dso/DsoCart.types';

const PERIOD_LABELS: Record<string, string> = {
  '1Y': 'year',
  half_year: 'half-year',
  '1Q': 'quarter',
  '1M': 'month',
  year: 'year',
  'half-year': 'half-year',
  quarter: 'quarter',
  month: 'month',
};

export const getDsoCartErrorMessage = (
  error: DsoCartValidationError
): string => {
  switch (error.error_code) {
    case DsoCartErrorCode.OUT_OF_STOCK:
      return `"${error.product_name}" is currently out of stock.`;

    case DsoCartErrorCode.INSUFFICIENT_STOCK:
      return `"${error.product_name}" does not have enough stock. You requested ${error.requested_quantity}, but only ${error.available_quantity} are available.`;

    case DsoCartErrorCode.TIME_LIMIT_EXCEEDED: {
      const period = PERIOD_LABELS[error.limit_period] ?? error.limit_period;
      return `"${error.product_name}" exceeds the purchase limit. You can order up to ${error.max_quantity} per ${period}. You have already ordered ${error.ordered_quantity}, with ${error.remaining} remaining.`;
    }

    case DsoCartErrorCode.MAX_PER_ORDER_EXCEEDED:
      return `"${error.product_name}" exceeds the maximum quantity per order. The limit is ${error.max_quantity_per_order}, but you requested ${error.requested_quantity}.`;

    case DsoCartErrorCode.MIN_PER_ORDER_NOT_MET:
      return `"${error.product_name}" does not meet the minimum quantity per order. The minimum is ${error.min_quantity_per_order}, but you requested ${error.requested_quantity}.`;

    case DsoCartErrorCode.INVALID_ORDER_MULTIPLE:
      return `"${error.product_name}" must be ordered in multiples of ${error.order_multiple}. You requested ${error.requested_quantity}.`;

    case DsoCartErrorCode.PRODUCT_INACTIVE:
      return `"${error.product_name}" is no longer available.`;

    case DsoCartErrorCode.PRODUCT_NOT_AVAILABLE_DSO:
      return `"${error.product_name}" is not available for DSO ordering.`;

    case DsoCartErrorCode.PRICE_NOT_AVAILABLE:
      return `"${error.product_name}" does not have a price available for ${error.country} (${error.currency}).`;

    default:
      return 'An unexpected error occurred. Please try again.';
  }
};

export const isDsoCartValidationError = (
  data: unknown
): data is DsoCartValidationError => {
  return (
    typeof data === 'object' &&
    data !== null &&
    'error_code' in data &&
    typeof (data as DsoCartValidationError).error_code === 'string' &&
    Object.values(DsoCartErrorCode).includes(
      (data as DsoCartValidationError).error_code
    )
  );
};
